import { ModicaButton } from "@modica-library/button/react";
import type { MouseEvent, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost";
type Props = {
  variant?: Variant;
  size?: "sm" | "md" | "lg";
  block?: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
  onClick?: (e: MouseEvent) => void;
  className?: string;
  children: ReactNode;
};

const VARIANT: Record<Variant, "primary" | "secondary" | "tertiary"> = {
  primary: "primary",
  secondary: "secondary",
  ghost: "tertiary",
};

/** Thin wrapper over @modica-library/button. Keeps our (children + onClick) API;
 *  bridges type="submit" to the enclosing form since the web component isn't a native submit. */
export function Button({ variant = "primary", block, disabled, type = "button", onClick, className, children }: Props) {
  // The generated react wrapper drops unknown props (className never reaches
  // the element), so layout classes live on a wrapper span we own.
  return (
    <span className={className} style={{ display: block ? "block" : "inline-block" }}>
      <ModicaButton
        variant={VARIANT[variant]}
        buttonText={String(children)}
        fullWidth={block}
        disabled={disabled}
        onClick={(e: MouseEvent) => {
          onClick?.(e);
          if (type === "submit") {
            const form = (e.currentTarget as HTMLElement | null)?.closest("form");
            form?.requestSubmit();
          }
        }}
      />
    </span>
  );
}
